import { v } from 'convex/values'

// PostHog flag `onboarding-paywall`. In 'trial-paywall' onboarding ends on a card
// trial paywall and the no-card trial is never granted.
export const PAYWALL_FLAG = 'onboarding-paywall'
export const paywallVariantValidator = v.union(v.literal('control'), v.literal('trial-paywall'))
export type PaywallVariant = 'control' | 'trial-paywall'

export const asPaywallVariant = (raw: unknown): PaywallVariant | null =>
  raw === 'control' || raw === 'trial-paywall' ? raw : null
